export default "__VITE_ASSET__Crso955W__"